module.exports = __webpack_public_path__ + "static/exercise-img-8-a3785404af8e51cec6cd691cc47fb5bd.png";